import styled, { css } from 'styled-components/macro'

const labelFocus = css`
  z-index: 0;
  outline: 2px solid var(--focus-ring);
  outline-offset: 1px;
`

export const Wrap = styled.div`
  display: flex;
`

export const Input = styled.input`
  position: relative;
  display: none;
  &:disabled + label {
    cursor: not-allowed;
    pointer-events: none;
    /* DS disabled control pair (same as Button :disabled) — the previous
       pearl-line-family literal stayed light under the dark themes */
    background-color: var(--gray-200);
    color: var(--gray-400);
  }

  /* DS selected state — lavender wash + deep-purple ink (the legacy
     mountainMeadow green predates the redesign's selection language) */
  &:checked&:disabled + label {
    background-color: var(--surface-brand-soft);
    color: var(--gray-400);
  }

  &:checked + label {
    /* de-islanded selected chip: lavender wash #f1eefc -> --surface-brand-soft,
       ink --deep-purple -> --action-primary so both re-theme in dusk/midnight;
       the inset --deep-swell ring is a fixed vivid accent that reads on both. */
    background-color: var(--surface-brand-soft);
    box-shadow: inset 0 0 0 1px var(--deep-swell);
    color: var(--action-primary);
  }

  &:focus + label {
    ${labelFocus}
  }
`

export const Label = styled.label<{ htmlFor: string }>`
  display: flex;
  height: 100%;
  padding: 1rem;
  cursor: pointer;
  /* resting tile rides the themed card surface (pearl value IS the previous
     literal white) — the fixed white tiles were the dusk light-artifact */
  background-color: var(--surface-card);
  &:hover {
    background-color: var(--surface-page);
  }
  transition: all 255ms ease;
  span {
    align-self: center;
    /* options are often lowercase-authored; the legacy bar shouted them in
       all-caps — Title Case matches the surrounding field labels */
    text-transform: capitalize;
  }
`

export const InputWrap = styled.div<{ disabled?: boolean }>`
  font-weight: var(--font-weight-medium);
  font-size: var(--mantine-font-size-sm);
  line-height: var(--mantine-line-height-snug);
  text-align: center;
  display: flex;
  align-items: center;
  /* themed lavender hairline (pearl value IS the previous literal) */
  border: 0.0625rem solid var(--border-lavender);
  &:not(:last-of-type) {
    border-right: 0;
  }
  &:first-of-type,
  &:first-of-type label {
    border-top-left-radius: calc(var(--mantine-radius-sm) * 0.75);
    border-bottom-left-radius: calc(var(--mantine-radius-sm) * 0.75);
  }
  &:last-of-type,
  &:last-of-type label {
    border-top-right-radius: calc(var(--mantine-radius-sm) * 0.75);
    border-bottom-right-radius: calc(var(--mantine-radius-sm) * 0.75);
  }
`
